import { useEffect, useState } from 'react'

import { getArchitecture } from 'services/get-architecture'

export function useArchitecture() {
    const [architecture, setArchitecture] = useState<'x64' | 'arm' | undefined>(undefined)

    useEffect(() => {
        Promise.resolve(getArchitecture()).then((architecture) => {
            setArchitecture(architecture)
        })
    }, [])

    return architecture
}
